import linkAccountModel from 'purchase/checkout/linkAccount/linkAccountModel';
import {
	getUrl,
	handleResponse,
} from 'purchase/checkout/linkAccount/linkAccountUtility';
import { getPageUrl } from 'global/analyticsUtilities';
import { Events } from 'global/constants';

export const setup = () => {
	const parentDiv = document.querySelector('[data-customer-type-selection]');
	if (parentDiv) {
		setupButtonEvents();
		channelSwitch();
	}
};

const setupButtonEvents = () => {
	const button = document.getElementById('customerAccountLinkModalBtn');
	button.addEventListener('click', () => {
		coreMetricsAccountLinkStart();
		setupModal();
	});
};

const coreMetricsAccountLinkStart = () => {
	const data = { url: getPageUrl() };
	window.od.pubsub.publish(Events.ACCOUNT_LINK_CHECKOUT_START, data);
};

const channelSwitch = () => {
	const customerTypeBusiness = document.getElementById('customerTypeBusiness');
	const customerTypeConsumer = document.getElementById('customerTypeConsumer');
	const B2BUrl = document.getElementById('setB2BUrl').value;
	const B2CUrl = document.getElementById('setB2CUrl').value;

	const setChannelType = (elem, type) => {
		elem.addEventListener('click', function () {
			self.location = type;
		});
	};

	setChannelType(customerTypeBusiness, B2BUrl);
	setChannelType(customerTypeConsumer, B2CUrl);
};

export const setupModal = () => {
	const url = getUrl('customerAccountLinkModalBtn');
	return linkAccountModel({}, url)
		.then(handleResponse)
		.catch(() => null);
};

export default setup;
